class Helper {
  constructor() {
    if (Helper.instance) {
      return Helper.instance;
    }
    Helper.instance = this;
    this.name = 'Helper';
  }

  getDayEnding(number) {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
      return 'день';
    }
    if ([2, 3, 4].includes(lastDigit) && ![12, 13, 14].includes(lastTwoDigits)) {
      return 'дня';
    }
    return 'дней';
  }
}

export default new Helper();
